export enum PropertyDataType {
  Text = 'text',
  Dropdown = 'dropdown',
}
